import { render, staticRenderFns } from "./CsgoSettings.vue?vue&type=template&id=6fa49922&scoped=true"
import script from "./CsgoSettings.vue?vue&type=script&lang=js"
export * from "./CsgoSettings.vue?vue&type=script&lang=js"
import style0 from "./CsgoSettings.vue?vue&type=style&index=0&id=6fa49922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa49922",
  null
  
)

export default component.exports